import { type Product } from '@/domain/products/types';
import { REPO_URL } from '@/services/api';

interface RepositoryDocumentFrameProps {
  product: Product;
  documentPath: string;
}

export const RepositoryDocumentFrame = ({ product, documentPath }: RepositoryDocumentFrameProps) => (
  <iframe
    title={product.product}
    id={product.product}
    name={product.product}
    sandbox="allow-same-origin"
    src={`${REPO_URL}/${documentPath}`}
    style={{ width: '100%', height: '100%' }}
    allowFullScreen
  />
);
